import { useAppSelector } from '@/store/stores'
import { selectInterfaces, selectInterfacesByOrganization, selectIsViewOnly, selectPermissionLoading } from '@/store/selectors/UserSelector'

/**
 * @desc:
 * to be refactored: remove this file and use directly the selectors
 */
const usePermission = () => {
  const interfaces = useAppSelector(selectInterfaces)
  const interfacesByOrganization = useAppSelector(selectInterfacesByOrganization)
  const isViewOnly = useAppSelector(selectIsViewOnly)
  const isLoading = useAppSelector(selectPermissionLoading)

  return {
    interfaces,
    interfacesByOrganization,
    isViewOnly,
    isLoading,
  }
}

export default usePermission
